import { createSlice } from '@reduxjs/toolkit';

const applicationSlice = createSlice({
    name: "application",
    initialState:{},
   reducers: {
        setInitial(state, action) {
            const { uiData,applictionName } = action.payload;
            state = uiData[applictionName];
            return state;
        }
    }
})

export const applicationActions = applicationSlice.actions;
export default applicationSlice
